(function () {
    'use strict';

    function ProductBundleManager(root) {
        this.root = root;
        this.bundleGroups = [];
        this.addToCartButton = null;
        this.selectedVariants = [];
    }

    ProductBundleManager.prototype = Object.assign({}, ProductBundleManager.prototype, {
        connectedCallback: function () {
            var root = this.root;
            this.bundleGroups = Array.prototype.slice.call(root.querySelectorAll('.ProductMeta__BundleGroup'));
            this.addToCartButton = root.querySelector('.ProductForm__Bundle__AddToCart');

            if (!this.addToCartButton) {
                return;
            }

            this.setSelectedVariants();
            this.initializeGroupLinks();
            this.setupBundleGroupEvents();
            this.addToCartButton.addEventListener('click', this.addBundleToCart.bind(this));
        },

        initializeGroupLinks: function () {
            var self = this;
            this.bundleGroups.forEach(function (group) {
                var selectedProduct = group.querySelector('.ProductMeta__BundleProduct.selected');
                var link = group.querySelector('.ProductMeta__BundleGroup__Link');

                if (selectedProduct && link) {
                    var productUrl = selectedProduct.dataset.url || '#';
                    link.setAttribute('href', productUrl);
                    link.href = productUrl;
                    link.textContent = selectedProduct.dataset.productTitle || selectedProduct.dataset.color || '';
                }
            });
        },

        setupBundleGroupEvents: function () {
            var self = this;

            this.bundleGroups.forEach(function (group) {
                var products = Array.prototype.slice.call(group.querySelectorAll('.ProductMeta__BundleProduct'));
                var productFormOptions = Array.prototype.slice.call(group.querySelectorAll('.ProductForm__Bundle__Option'));

                products.forEach(function (product) {
                    product.addEventListener('click', function (e) {
                        var productId = product.dataset.productId;

                        self.removeAndAddClass(products, product, 'selected');

                        var selectedOption = productFormOptions.find(function (option) {
                            return option.dataset.productId === productId;
                        });

                        if (selectedOption) {
                            self.removeAndAddClass(productFormOptions, selectedOption, 'selected');
                        }

                        var preview = group.querySelector('.ProductMeta__BundleGroup__Preview img');
                        var link = group.querySelector('.ProductMeta__BundleGroup__Link');

                        if (preview) {
                            preview.src = product.dataset.featuredImage || '';
                        }
                        if (link) {
                            var productUrl = product.dataset.url || '#';
                            link.setAttribute('href', productUrl);
                            link.href = productUrl;
                            link.textContent = product.dataset.productTitle || product.dataset.color || '';
                            // Force browser to recognize the href change
                            link.removeAttribute('href');
                            link.setAttribute('href', productUrl);
                        }

                        self.setSelectedVariants();
                        self.validateBundleManager();
                        self.updateBundleGalleryImage(group, product);
                    });
                });

                var radioInputs = Array.prototype.slice.call(group.querySelectorAll('.ProductForm__Bundle__Option input[type="radio"], .ProductForm__Bundle__Option input[type="hidden"]'));
                radioInputs.forEach(function (input) {
                    input.addEventListener('change', function () {
                        if (input.type === 'radio' && !input.checked) {
                            return;
                        }

                        var inputValue = input.value;
                        var optionContainer = input.closest('.ProductForm__Bundle__Option');
                        if (!optionContainer) {
                            return;
                        }

                        var productId = optionContainer.dataset.productId;
                        var variantAvailable = input.dataset.variantAvailable === 'true';
                        var variantId = input.dataset.variantId;
                        var productIndex = input.closest('.ProductMeta__BundleGroup').dataset.index;

                        if (self.selectedVariants[productIndex]) {
                            self.selectedVariants[productIndex].productId = parseInt(productId, 10);
                            self.selectedVariants[productIndex].variantId = parseInt(variantId, 10);
                            self.selectedVariants[productIndex].variantTitle = inputValue;
                            self.selectedVariants[productIndex].variantAvailable = variantAvailable;
                        }

                        self.validateBundleManager();
                    });
                });
            });
        },

        setSelectedVariants: function () {
            var self = this;
            this.selectedVariants = this.bundleGroups.map(function (group, index) {
                var selectedBundleProduct = group.querySelector('.ProductMeta__BundleProduct.selected');
                var matchingBundleOption = group.querySelector('.ProductForm__Bundle__Option.selected');
                var productId = selectedBundleProduct ? selectedBundleProduct.dataset.productId : null;

                var variantValue = null;
                var variantId = null;
                var variantAvailable = false;

                if (matchingBundleOption) {
                    var input = matchingBundleOption.querySelector('input:checked') || matchingBundleOption.querySelector('input[type="hidden"]');
                    if (input) {
                        variantValue = input.value;
                        variantId = input.dataset.variantId;
                        variantAvailable = input.dataset.variantAvailable === 'true';
                    }
                }

                return {
                    index: index,
                    productId: productId ? parseInt(productId, 10) : null,
                    variantId: variantId ? parseInt(variantId, 10) : null,
                    variantTitle: variantValue,
                    variantAvailable: variantAvailable
                };
            });
        },

        removeAndAddClass: function (list, item, className) {
            list.forEach(function (i) {
                i.classList.remove(className);
            });
            if (item) {
                item.classList.add(className);
            }
        },

        validateBundleManager: function () {
            var isAllSelected = this.selectedVariants.every(function (v) {
                return v.productId && v.variantId;
            });
            var inStock = this.selectedVariants.every(function (v) {
                return v.variantAvailable;
            });

            if (isAllSelected && inStock) {
                this.addToCartButton.removeAttribute('disabled');
                this.addToCartButton.textContent = 'Legg i handlekurv';
            } else if (isAllSelected) {
                this.addToCartButton.setAttribute('disabled', true);
                this.addToCartButton.textContent = 'Ikke på lager';
            } else {
                this.addToCartButton.setAttribute('disabled', true);
                this.addToCartButton.textContent = 'Velg produkter og størrelser';
            }
        },

        updateBundleGalleryImage: function (group, selectedProduct) {
            var groupIndex = group.dataset.index;
            var alt = selectedProduct.dataset.productTitle || '';
            var img1Src = selectedProduct.dataset.galleryImage || selectedProduct.dataset.featuredImage || '';
            var img2Src = selectedProduct.dataset.galleryImage2 || '';

            // Desktop gallery (two images per row)
            var galleryRow = document.querySelector('[data-bundle-image-index="' + groupIndex + '"]');
            if (galleryRow) {
                var desktopImg1 = galleryRow.querySelector('[data-bundle-img="1"]');
                var desktopImg2 = galleryRow.querySelector('[data-bundle-img="2"]');
                var col2 = desktopImg2 ? desktopImg2.parentElement : null;

                if (desktopImg1 && img1Src) {
                    desktopImg1.src = img1Src;
                    desktopImg1.alt = alt;
                }
                if (img2Src) {
                    if (desktopImg2) {
                        desktopImg2.src = img2Src;
                        desktopImg2.alt = alt;
                        col2.style.display = '';
                    } else {
                        // Create second column if it doesn't exist yet
                        var newCol = document.createElement('div');
                        newCol.className = 'product-bundle-images__col';
                        var newImg = document.createElement('img');
                        newImg.src = img2Src;
                        newImg.alt = alt;
                        newImg.width = 800;
                        newImg.setAttribute('data-bundle-img', '2');
                        newCol.appendChild(newImg);
                        galleryRow.appendChild(newCol);
                    }
                } else if (col2) {
                    col2.style.display = 'none';
                }
            }

            // Mobile inline image (single image below picker)
            var mobileSlot = group.querySelector('[data-bundle-mobile-image]');
            if (mobileSlot) {
                var mobileImg = mobileSlot.querySelector('img');
                if (mobileImg && img1Src) {
                    mobileImg.src = img1Src;
                    mobileImg.alt = alt;
                }
            }
        },

        addBundleToCart: function () {
            var root = this.root;
            var bundleProductVariantId = root.dataset.mainProductVariantId;
            var bundleId = new Date().getTime();
            var bundleItems = this.selectedVariants.map(function (v) {
                return v.variantId;
            });

            // Build Shopify GIDs for variants
            var bundleItemGids = bundleItems.map(function (id) {
                return 'gid://shopify/ProductVariant/' + id;
            });

            // Base properties payload
            var properties = {
                _bundleId: bundleId,
                _bundle_items: JSON.stringify(bundleItemGids)
            };

            // Human-readable labels for tops (group 0) and bottoms (group 1)
            if (this.bundleGroups[0] && this.selectedVariants[0]) {
                var group0 = this.bundleGroups[0];
                var selected0 = group0.querySelector('.ProductMeta__BundleProduct.selected');
                var size0 = this.selectedVariants[0].variantTitle || '';
                var name0 = selected0 ? (selected0.getAttribute('data-product-title') || '') : '';
                if (name0 || size0) {
                    var label0 = name0;
                    if (size0 && size0 !== 'Default Title') {
                        label0 += ' – ' + size0;
                    }
                    properties._bundle_top = label0;
                }
            }

            if (this.bundleGroups[1] && this.selectedVariants[1]) {
                var group1 = this.bundleGroups[1];
                var selected1 = group1.querySelector('.ProductMeta__BundleProduct.selected');
                var size1 = this.selectedVariants[1].variantTitle || '';
                var name1 = selected1 ? (selected1.getAttribute('data-product-title') || '') : '';
                if (name1 || size1) {
                    var label1 = name1;
                    if (size1 && size1 !== 'Default Title') {
                        label1 += ' – ' + size1;
                    }
                    properties._bundle_bottom = label1;
                }
            }

            if (this.bundleGroups[2] && this.selectedVariants[2]) {
                var group2 = this.bundleGroups[2];
                var selected2 = group2.querySelector('.ProductMeta__BundleProduct.selected');
                var size2 = this.selectedVariants[2].variantTitle || '';
                var name2 = selected2 ? (selected2.getAttribute('data-product-title') || '') : '';
                if (name2 || size2) {
                    var label2 = name2;
                    if (size2 && size2 !== 'Default Title') {
                        label2 += ' – ' + size2;
                    }
                    properties._bundle_third = label2;
                }
            }

            var self = this;
            fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    items: [{
                        id: bundleProductVariantId,
                        quantity: 1,
                        properties: properties
                    }]
                })
            })
                .then(function (response) {
                    return response.json();
                })
                .then(function (data) {
                    if (data.status === 422) {
                        console.error('Error adding bundle to cart:', data);
                    } else {
                        document.dispatchEvent(new CustomEvent('product:added', { detail: { quantity: 1 } }));
                        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                            detail: {
                                product: data,
                                addToCartBtn: self.addToCartButton
                            }
                        }));
                    }
                })
                .catch(function (error) {
                    console.error('Error adding bundle to cart:', error);
                });
        }
    });

    var initManagers = function () {
        var managers = document.querySelectorAll('product-bundle-manager');
        Array.prototype.slice.call(managers).forEach(function (manager) {
            if (manager._bundleManagerInitialized) {
                return;
            }
            var instance = new ProductBundleManager(manager);
            instance.connectedCallback();
            manager._bundleManagerInitialized = true;
        });
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initManagers);
    } else {
        setTimeout(initManagers, 100);
    }

    document.addEventListener('ajaxProduct:added', function () {
        setTimeout(initManagers, 500);
    });
})();
